module.exports = __webpack_public_path__ + "static/media/seach_icom_blue.99ba828d.png";